
import { defineComponent } from 'vue';

export default defineComponent({
    name: "Zone Connection Information",
    data: ()=>({
        content: { } as any
     }),

    props: {
        zoneContent: {
            type: Object,
            default: null
        },
        zoneNumber: {
            type: Number,
            default: null
        },
        zoneType: {
            type: String,
            default: null
        },
        contentName: {
            type: String,
            default: null
        }
    },

    async created() {
        this.content = { }
    },

    watch: {
        'content': {
            handler(newValue: any){
                this.$emit('updateSignageZones', {zoneNumber: this.zoneNumber, zoneType: this.zoneType, updatedContent: newValue});
            },
            deep: true
        }
    }
})
